import { firebase } from "../firebase";

export const submitVerify = async (
  id: string,
  additionalInfo: string = "",
  address1: string = "",
  address2: string = "",
  city: string = "",
  state: string = "",
  postalCode: string = "",
  country: string = "",
  firstName: string = "",
  lastName: string = "",
  websiteURL: string = "",
  email: string = "",
  phone: string = "",
  legalBusinessName: string = "",
  businessIdentifier: string = "",
  businessIdentifierType: string = "",
  businessRegistrationType: string = "",
) => {
  const currentUser = firebase.auth().currentUser;

  const token = await currentUser?.getIdToken(true);
  const body = {
    id,
    additionalInfo,
    firstName,
    lastName,
    city,
    state,
    postalCode,
    country,
    address1,
    email,
    phone,
    websiteURL,
    legalBusinessName,
  };
  if (address2 && address2.length > 0) {
    body["address2"] = address2;
  }
  if (businessIdentifier && businessIdentifier.length > 0) {
    body["businessIdentifier"] = businessIdentifier;
  }
  if (businessIdentifierType && businessIdentifierType.length > 0) {
    body["businessIdentifierType"] = businessIdentifierType;
  }
  if (businessRegistrationType && businessRegistrationType.length > 0) {
    body["businessRegistrationType"] = businessRegistrationType;
  }

  const response = await fetch(`cs/verify`, {
    body: JSON.stringify(body),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accepts: "application/json",
    },
  });

  const dt = await response.json();
  if (!response.ok || (response.status > 200 && response.status < 600)) {
    throw new Error(dt.message || response.statusText);
  }

  return;
};
